// Angular
import { Component, OnInit, OnDestroy, ViewChild, Renderer2, ViewContainerRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

// Kendo
import { AddEvent, EditEvent, GridComponent } from '@progress/kendo-angular-grid';
import { groupBy, GroupDescriptor } from '@progress/kendo-data-query';

// Formly
import { FieldType } from '@ngx-formly/core';

// Services
import { WISEService } from 'app/_services';

// lodash
import * as _ from 'lodash';

const createFormGroup = dataItem => new FormGroup({
    'LineID': new FormControl(dataItem.LineID),
    'Vertrek': new FormControl(dataItem.Vertrek),
    'Lengte': new FormControl(dataItem.Lengte),
    'Breedte': new FormControl(dataItem.Breedte),
    'Hoogte': new FormControl(dataItem.Hoogte),
    'Calculatie': new FormControl(dataItem.Calculatie)
});

const matches = (el, selector) => (el.matches || el.msMatchesSelector).call(el, selector);

@Component({
    selector: 'formly-field-grid-afmetingen',
    templateUrl: './grid-afmetingen.type.component.html',
})
export class FormlyFieldGridAfmetingen extends FieldType implements OnInit, OnDestroy {
    @ViewChild('kendoGrid', { static: true, read: ViewContainerRef }) _grid: GridComponent;
    @ViewChild(GridComponent, { static: true }) private grid: GridComponent;

    public view: any[] = [];

    public formGroup: FormGroup;

    private editedRowIndex: number;
    private docClickSubscription: any;
    private isNew: boolean;

    constructor(
        private service: WISEService,
        private renderer: Renderer2
    ) {
        super();
    }

    public addHandler(): void {
        this.closeEditor();

        this.formGroup = createFormGroup({
            'Vertrek': '',
            'Lengte': 0,
            'Breedte': 0,
            'Hoogte': 0,
            'Calculatie': 0
        });
        this.isNew = true;

        this.grid.addRow(this.formGroup);
    }

    public removeHandler({ sender, dataItem }) {
        const index = _.findIndex(this.view, dataItem);

        this.view.splice(index, 1);
        //this.model[this.field.key] = this.view;
        this.set(this.field.key, this.view);

        sender.cancelCell();
    }

    public cellClickHandler({ isEdited, dataItem, rowIndex }): void {
        if (isEdited || (this.formGroup && !this.formGroup.valid)) {
            return;
        }

        this.saveCurrent(this.formGroup);

        this.formGroup = createFormGroup(dataItem);
        this.editedRowIndex = rowIndex;

        this.grid.editRow(rowIndex, this.formGroup);
    }

    public cancelHandler({ sender, dataItem }) {
        this.closeEditor();
    }

    private closeEditor(): void {
        this.grid.closeRow(this.editedRowIndex);

        this.isNew = false;
        this.editedRowIndex = undefined;
        this.formGroup = undefined;
    }

    private onDocumentClick(e: any): void {
        if (this.formGroup && this.formGroup.valid &&
            !matches(e.target, '#productsGrid tbody *, #productsGrid .k-grid-toolbar .k-button')) {
            this.saveCurrent(this.formGroup);
        }
    }

    public saveHandler({ sender, formGroup, rowIndex }) {
        if (formGroup.valid) {
            this.saveCurrent(formGroup);
        }
    }

    private saveCurrent(formGroup): void {
        if (formGroup) {
            if (this.isNew) {
                const measurement = formGroup.value;

                measurement.LineID = (this.view.length + 1);
                this.view.splice(0, 0, measurement);
            } else {
                Object.assign(
                    this.view.find(({ LineID }) => LineID === formGroup.value['LineID']),
                    formGroup.value
                );
            }

            //this.model[this.field.key] = this.view;
            this.set(this.field.key, this.view);
            this.closeEditor();
        }
    }

    private set(path, value) {
        let schema = this.model;  // a moving reference to internal objects within obj
        const pList = path.split('.');
        const len = pList.length;

        for (let i = 0; i < len - 1; i++) {
            const elem = pList[i];

            if (!schema[elem]) {
                schema[elem] = {};
            }

            schema = schema[elem];
        }

        schema[pList[len - 1]] = value;
    }

    public ngOnInit(): void {
        this.view = _.get(this.model, this.field.key);

        this.docClickSubscription = this.renderer.listen('document', 'click', this.onDocumentClick.bind(this));
    }

    public ngOnDestroy(): void {
        this.docClickSubscription();
    }
}
